export default "__VITE_ASSET__a918992f__"